import { Link } from 'react-router-dom';
import { BoardsTable } from '../admin/BoardsTable';
import { EraseUserRangeForm } from '../admin/EraseUserRangeForm';
import { AuditLog } from '../admin/AuditLog';
import { BanManager } from '../admin/BanManager';
import { ArrowLeftIcon, SettingsIcon } from '../ui/icons';
import ToastViewport from '../ui/Toast';

export default function Admin() {
  return (
    // R4-D-12: admin shell consumes brand-* tokens — parchment surface is the
    // brand 紫金 50 tint, header span is brand 600. Eliminates the visual
    // split where admin was neutral/emerald and user-facing surfaces 紫金.
    <div className="min-h-full bg-brand-50 text-neutral-900">
      <header className="sticky top-0 z-20 bg-white/80 backdrop-blur-xl border-b border-brand-100">
        <div className="max-w-6xl mx-auto px-6 h-14 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <span className="flex items-center justify-center w-8 h-8 rounded-lg bg-brand-600 text-white">
              <SettingsIcon size={16} />
            </span>
            <h1 className="text-[15px] font-semibold tracking-tight">管理员面板</h1>
          </div>
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 text-sm text-neutral-600 hover:text-neutral-900"
          >
            <ArrowLeftIcon size={14} />
            返回画板
          </Link>
        </div>
      </header>
      <main className="max-w-6xl mx-auto px-6 py-8 space-y-8">
        <BoardsTable />
        <BanManager />
        <EraseUserRangeForm />
        <AuditLog />
      </main>
      <ToastViewport />
    </div>
  );
}
